import {Component, OnInit, OnDestroy} from '@angular/core';
import {TravelsService, RoutingService} from '../../services';
import * as moment from 'moment';
import {STATE_NAMES} from "../../common";
import {Travel} from "../../models";



@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainPageComponent implements OnInit {
    travels: any;
    currentDate: any;
    days: any[];
    events: any[];
    eventsCount: number;
    isLoadedTravels = false;
    isLoadedEvents = false;

  constructor(
    private travelsService: TravelsService,
    private route: RoutingService,
  ){}

  ngOnInit() {

     this.currentDate = moment();
     this.getTravels();
   }

    onSelectedDateChange(day: any) {
      this.events = day.dayEvents;
      this.isLoadedEvents = true;
    }


    private getTravels() {
        this.travels = [];
        this.travelsService.getTravels({}).subscribe((res) => {
            if (res) {
                this.travels = res;
                this.isLoadedTravels = true;
                // console.log('!!!!this.travels', this.travels)
            }
        }, (err) => {
            this.isLoadedTravels = true;
            console.log('!!!!err', err)
        });

    }

    goToEvent (event: any) {
        this.route.go(STATE_NAMES.events, {
            event: event,
            // travel: item.travel
        });

    }

    openTravelProfile(e: any, travel: Travel) {
        this.route.go(STATE_NAMES.travel, {
            id: travel.id,
            travel: travel,
        });
    }
}
